// BFSG
import React from 'react'
import styled from 'styled-components'
import ProductImage from 'theme/atoms/ProductImage'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

type Props = {
  $isActive?: boolean
  $isHorizontal?: boolean
  altText?: string
  onMouseOver?: () => void
  onThumbnailClick?: () => void
  image: {
    type: 'image' | 'video'
    url: string
    classes: Array<'ASSET_FS' | string>
    videoIndex?: number
  }
  index: number
}

export default function Thumbnail(props: Props) {
  const t = useTranslations<'templates-PDP'>()
  const altText = props.altText || 'Thumbnail Image'
  const isVideo = props.image.type === 'video'

  return (
    <Wrapper
      $isActive={props.$isActive}
      $isHorizontal={props.$isHorizontal}
      data-cy-collection="Thumbnail"
      onMouseOver={props.onMouseOver}
      data-cy-state={props.$isActive ? 'active' : 'inactive'}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          props.onMouseOver?.()
          props.onThumbnailClick?.()
        }
      }}
      title={
        isVideo
          ? t.asText(false, 'select_gallery_thumbnail_video')
          : t.asText(false, 'select_gallery_thumbnail', {
              index: props.index + 1
            })
      }
    >
      {isVideo ? (
        <VideoThumbnail
          data-cy-handle="execute-thumbnail-click"
          onClick={() => props.onThumbnailClick?.()}
          data-cy-state="thumbnail-is-video"
          src={props.image.url}
          alt={altText}
        />
      ) : (
        <ProductImage
          data-cy-handle="execute-thumbnail-click"
          img={props.image}
          alt={altText}
          size="s"
          onClick={() => props.onThumbnailClick?.()}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.button<{ $isActive?: boolean; $isHorizontal?: boolean }>`
  ${(p) => p.$isHorizontal && 'height: 100%;'};
  cursor: pointer;
  aspect-ratio: 1/1;
  ${(p) => p.$isActive && `outline: 1px solid ${theme.colors.b0}`};
`

const VideoThumbnail = styled.img<{ $isHorizontal?: boolean }>`
  ${(p) => p.$isHorizontal && 'height: 100%;'};
  aspect-ratio: 1/1;
  width: 100%;
`
